import React, { useEffect, useState } from 'react';
import './Navbar.css';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={['nav', isScrolled ? 'nav--scrolled' : ''].join(' ').trim()}>
      <div className="nav__inner container">
        <a className="nav__brand" href="#top" aria-label="Go to top">
          <span className="nav__brandMark" aria-hidden>
            EO
          </span>
          <span className="nav__brandText">
            Emmanuel Obeng
            <span className="nav__brandSub">PMP® · ITIL 4 · Scrum · Security+</span>
          </span>
        </a>

        <nav className="nav__links" aria-label="Primary">
          <a className="nav__link" href="#services">
            Services
          </a>
          <a className="nav__link" href="#value">
            How It Works
          </a>
          <a className="nav__link" href="#credentials">
            Credentials
          </a>
          <a className="nav__link" href="#testimonials">
            Testimonials
          </a>
          <a className="nav__link" href="#contact">
            Contact
          </a>
        </nav>

        <a className="nav__cta" href="#work-with-me">
          Book a Free Audit
        </a>
      </div>
    </header>
  );
}
